import { IListParams } from 'models/settingsV2.model';
import { ACTION_IDS, ACTION_NAME, PAGE_NAMES, RESOURCES, SETTINGS_V2_ACTION } from '../../../../../settingsV2Constant';

export const makeActionList = (params: IListParams) => {
	const { hasPermission } = params;
	return {
		bulkActions: [],
		rowActions: [
			{
				name: ACTION_NAME.EDIT,
				id: ACTION_IDS.EDIT,
				isEnabled: () => {
					return hasPermission({
						configPageName: PAGE_NAMES.permissionsManagement,
						configResourceName: RESOURCES.permission,
						configActionName: SETTINGS_V2_ACTION.editPermission
					});
				}
			},
			{
				name: ACTION_NAME.DELETE,
				id: ACTION_IDS.DELETE,
				isEnabled: () => {
					return hasPermission({
						configPageName: PAGE_NAMES.permissionsManagement,
						configResourceName: RESOURCES.permission,
						configActionName: SETTINGS_V2_ACTION.deletePermission
					});
				}
			}
		],
		addAction: {
			name: ACTION_NAME.ADD,
			id: ACTION_IDS.ADD,
			isEnabled: () => {
				return hasPermission({
					configPageName: PAGE_NAMES.permissionsManagement,
					configResourceName: RESOURCES.permission,
					configActionName: SETTINGS_V2_ACTION.createPermission
				});
			}
		}
	};
};

export default {
	makeActionList
};
